import React from 'react'
import { Careers } from '../src/components'
import Footers from '../src/components/Footer'
import Header from '../src/components/Header'

export default function CareersPage() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <Careers />
      </div>
      <Footers />
    </>
  )
}
